export default __webpack_public_path__ + "assets/front/scss/common.11c0aaa86a3fb4ff77035da534847c40.css";